// extracted by mini-css-extract-plugin
module.exports = {"indicatorBox":"Controller_indicatorBox__K6v_m"};